
import React from "react";

interface HelpFieldProps {
  id: string;
  helpText?: string;
}

/**
 * @return {null}
 */
const HelpField: React.FC<HelpFieldProps> = ({ }) => {
  return null;
};

export default HelpField;
